import React, { useEffect, useRef, useState } from "react";
import { BarcodeDetector } from "barcode-detector";

const filters = [
  {
    s_no: 1,
    filter_unique_id: "ac1231",
    filter_type: "HEPA",
    filter_manufacturer: "AirClean Co.",
    installation_date: "2023-01-15",
    location_type: "Cleanroom",
    filter_dimensions: "610x610x305 mm",
    micron_rating: "0.3 µm",
    cleaning_frequency_days: 30,
    cleaning_frequency_allowance_days: 5,
    max_allowed_cleanings: 10,
    last_cleaning_date: "2024-12-01",
    valid_operational_life_days: 365,
    ahu_unique_id: "AHU-101",
    current_status: "Active",
    availability_status: "In Use",
    label: "PFI/AHU-060/SA/FAF/10µ/01-01/00 ",
  },
  {
    s_no: 2,
    filter_unique_id: "ac1232",
    filter_type: "Pre-filter",
    filter_manufacturer: "PureAir Ltd.",
    installation_date: "2023-03-10",
    location_type: "HVAC",
    filter_dimensions: "500x500x100 mm",
    micron_rating: "5 µm",
    cleaning_frequency_days: 60,
    cleaning_frequency_allowance_days: 10,
    max_allowed_cleanings: 5,
    last_cleaning_date: "2025-05-15",
    valid_operational_life_days: 180,
    ahu_unique_id: "AHU-102",
    current_status: "Cleaning",
    availability_status: "Unavailable",
    label: "GMB/AHU-002/SA/FAF/10µ/01-01/00",
  },
  {
    s_no: 3,
    filter_unique_id: "ac1233",
    filter_type: "Bag filter",
    filter_manufacturer: "FilterTech",
    installation_date: "2022-11-20",
    location_type: "Warehouse",
    filter_dimensions: "800x400x200 mm",
    micron_rating: "10 µm",
    cleaning_frequency_days: 90,
    cleaning_frequency_allowance_days: 7,
    max_allowed_cleanings: 6,
    last_cleaning_date: "2025-04-20",
    valid_operational_life_days: 540,
    ahu_unique_id: "AHU-103",
    current_status: "Active",
    availability_status: "Spare",
    label: " FD/AHU-010/SA/BAF/10µ/01-01/00",
  },
];

const BarcodeScanner = () => {
  const videoRef = useRef(null);
  const [scanning, setScanning] = useState(false);
  const [showRescan, setShowRescan] = useState(false);
  const [matchedFilter, setMatchedFilter] = useState(null);

  const startScan = async () => {
    if (scanning) return;
    setScanning(true);
    setShowRescan(false);
    setMatchedFilter(null);
    try {
      const detector = new BarcodeDetector({
        formats: ["qr_code", "ean_13", "code_128"],
      });

      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
      });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;

        await new Promise((resolve) => {
          videoRef.current.onloadedmetadata = () => {
            videoRef.current.play();
          };
          videoRef.current.onplaying = () => {
            resolve();
          };
        });
      }

      setTimeout(() => detect(detector), 500);
    } catch (err) {
      alert(`Camera error: ${err.message}`);
      setScanning(false);
      setShowRescan(true);
    }
  };

  const detect = async (detector) => {
    if (!videoRef.current) return;

    try {
      const barcodes = await detector.detect(videoRef.current);
      if (barcodes.length > 0) {
        const value = barcodes[0].rawValue;

        const foundFilter = filters.find(
          (filter) => filter.filter_unique_id === value
        );

        if (foundFilter) {
          setMatchedFilter(foundFilter);
        } else {
          alert(`Filter with ID ${value} not found.`);
        }

        stopCamera();
        setScanning(false);
        setShowRescan(true);
      } else {
        requestAnimationFrame(() => detect(detector));
      }
    } catch (err) {
      alert(`Detection error: ${err.message}`);
      stopCamera();
      setScanning(false);
      setShowRescan(true);
    }
  };

  const stopCamera = () => {
    if (videoRef.current?.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
  };

  useEffect(() => {
    startScan();
    return () => stopCamera();
  }, []);

  const getLocalDateTime = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const local = new Date(now.getTime() - offset * 60000);
    return local.toISOString().slice(0, 16);
  };
  console.log(matchedFilter);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div style={{ padding: 20 }}>
          <div className="d-flex justify-content-between align-items-center">
            <h2>{matchedFilter ? "Update Filter Status" : "Scan Barcode"}</h2>

            {showRescan && (
              <button
                onClick={startScan}
                style={{ marginTop: 20 }}
                className="btn btn-secondary"
              >
                Rescan
              </button>
            )}
          </div>

          {scanning ? (
            <video
              ref={videoRef}
              autoPlay
              playsInline
              style={{ width: "100%", maxWidth: 600 }}
            />
          ) : (
            <p></p>
          )}

          {/* {matchedFilter && (
            <div style={{ marginTop: 20 }}>
              <h4>Matched Filter Details:</h4>
              <pre>{JSON.stringify(matchedFilter, null, 2)}</pre>
            </div>
          )} */}

          {matchedFilter && (
            <div className="card">
              {/* <div className="card-header">Update Filter Status</div> */}
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className=" col-12 col-md-6 col-lg-4 mb-3">
                      <label className="form-label">Filter Code</label>
                      <input
                        type="text"
                        className="form-control"
                        value={matchedFilter?.filter_unique_id || ""}
                        disabled
                      />
                    </div>
                    <div className=" col-12 col-md-6 col-lg-4 mb-3">
                      <label className="form-label">Location</label>
                      <input
                        type="text"
                        className="form-control"
                        value={matchedFilter?.location_type || ""}
                        disabled
                      />
                    </div>

                    <div className="col-12 col-md-6 col-lg-4 mb-3">
                      <label className="form-label">Performed By</label>
                      <input
                        type="text"
                        className="form-control"
                        value={"Rama krishna"}
                        disabled
                      />
                    </div>

                    <div className="col-12 col-md-6 col-lg-4 mb-3">
                      <label className="form-label">Date</label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        value={getLocalDateTime()}
                        disabled
                      />
                    </div>

                    <div className=" col-12 col-md-6 col-lg-4 mb-3">
                      <label className="form-label">Previous Status</label>
                      <input
                        type="text"
                        className="form-control"
                        value="Wash-In"
                        disabled
                      />
                    </div>

                    <div className="col-12 col-md-6 col-lg-4 mb-3">
                      <label className="form-label">New Status</label>
                      <select className="form-select" name="status" required>
                        <option value="">Select Status</option>
                        <option value="Wash-In">Wash-In</option>
                        <option value="Wash-Out">Wash-Out</option>
                        <option value="Dry-In">Dry-In</option>
                        <option value="Dry-Out">Dry-Out</option>
                        <option value="Storage-In">Storage-In</option>
                        <option value="Storage-Out">Storage-Out</option>
                        <option value="Replace">Replace</option>
                        <option value="Retire">Retire</option>
                      </select>
                    </div>
                    <div className="col-12 mb-3">
                      <label className="form-label">Remarks</label>
                      <textarea
                        name="remarks"
                        className="form-control"
                        rows="3"
                      ></textarea>
                    </div>
                  </div>
                </form>
              </div>
              <div className="card-footer">
                <div className="d-flex justify-content-end">
                  <button className="btn btn-danger me-2" onClick={startScan}>
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={startScan}>
                    Update
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BarcodeScanner;
